import { render, staticRenderFns } from "./related-posts.component.vue?vue&type=template&id=2410d5ca&"
import script from "./related-posts.component.vue?vue&type=script&lang=js&"
export * from "./related-posts.component.vue?vue&type=script&lang=js&"
import style0 from "./related-posts.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports